<template>
    <!-- 退票 -->
    <div>
        <el-table
            :data="pageData"
            v-loading="loading"
            style="width: 100%"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="订单编号" class-name="fz12" prop="orderNo"></el-table-column>
            <el-table-column label="退票单号" width="90" class-name="fz12">
                <template slot-scope="scope">{{scope.row.serviceNo}}</template>
            </el-table-column>
            <el-table-column label="申请日期" width="90" class-name="fz12">
                <template slot-scope="scope">{{scope.row.applyDate}}</template>
            </el-table-column>
            <el-table-column label="票号" class-name="fz12">
                <template slot-scope="scope">
                    <div v-if="scope.row.ticketNumber">
                        <div
                            v-for="(ticket,index) in scope.row.ticketNumber.split(',')"
                            :key="index"
                        >
                            <p>{{ticket}}</p>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="乘机人" class-name="fz12">
                <template slot-scope="scope">
                    <div v-if="scope.row.psgName">
                        <div v-for="(psg,index) in scope.row.psgName.split(',')" :key="index">
                            <p>{{index + 1}}.{{psg}}</p>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="退票金额" class-name="fz12" prop="refundMoney">
                <template slot-scope="scope">¥{{scope.row.money}}</template>
            </el-table-column>
            <el-table-column label="币种" class-name="fz12" prop="currenciesType"></el-table-column>
            <el-table-column label="订单状态" class-name="fz12">
                <template slot-scope="scope">{{scope.row.serviceStatusText}}</template>
            </el-table-column>
            <el-table-column label="支付方式" class-name="fz12">
                <template slot-scope="scope">{{scope.row.payTypeText}}</template>
            </el-table-column>
            <el-table-column label="支付流水号" class-name="fz12">
                <template slot-scope="scope">{{scope.row.payTradeNo}}</template>
            </el-table-column>
            <el-table-column label="退款流水号" class-name="fz12">
                <template slot-scope="scope">{{scope.row.refundTradeNo}}</template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit("getItem", val);
    }
  },
  props: {
    pageData: Array,
    loading: Boolean
  }
};
</script>
<style lang="less" scoped>
</style>